<!-- vue模板 -->
<template>
  <div class="lcltext">
    <el-button class="copy-text-btn" type="primary" @click="copyTextEvent" icon="el-icon-document-copy">一键复制文本</el-button>
    <div class="copy-text-content">
      <div class="lcltext-item">
        <p>业务类型：海进拼箱</p>
        <p>船公司：{{ lclInfo.lclInfo.F_ShoppingCompany }}</p>
        <p>起运港：{{ lclInfo.lclInfo.FromPortName }} {{ lclInfo.lclInfo.FromPortEnglish }}</p>
        <p>目的港：{{ lclInfo.lclInfo.ToPortName }} {{ lclInfo.lclInfo.ToPortEnglish }}</p>
        <p>航程：{{ lclInfo.lclInfo.F_Voyage }}</p>
        <p>收货人：{{ lclInfo.lclInfo.ConsigneeTypeName }}</p>
        <p>运输方式：{{ lclInfo.lclInfo.F_SpellState === '1' ? '直拼' : '中转' }}</p>
        <p v-if="lclInfo.lclInfo.F_SpellState !== '1'">中转港：{{ lclInfo.lclInfo.TransitPortEnglish || '--' }}</p>
        <p>班期：{{ lclInfo.lclInfo.F_ShiftPeriod }}</p>
        <p>截关时间：{{ lclInfo.lclInfo.F_CutoffPeriod }}</p>
        <p>报价公司：{{ lclInfo.lclInfo.Contact.CompanyName || '--' }}</p>
        <p v-for="(value, index) in lclInfo.lclInfo.Efw_WarehouseArr" :key="index">接货仓库：{{ value.F_WarehouseName }}</p>
        <p>件数：{{ lclInfo.pcs }}PKG(S)</p>
        <p>重量：{{ lclInfo.kgs }}KGS</p>
        <p>体积：{{ lclInfo.cbm }}CBM</p>
        <p>是否包含报关费： {{ lclInfo.clearanceText === 1? '是' : '否' }}</p>
        <p>运输条款： {{ lclInfo.termText || '--' }}</p>
        <p>是否陆运：{{ lclInfo.landNum === 0 ? "否" : "是" }}</p>
        <p v-if="lclInfo.landNum !== 0">起运地：{{ lclInfo.areaText || '--' }}</p>
        <p>有效期：{{ lclInfo.lclInfo.F_StartTime }} 至 {{ lclInfo.lclInfo.F_EndTime }}</p>
        <p>联系人：{{ lclInfo.lclInfo.Contact.F_RealName || '--' }}</p>
        <p>联系电话：{{ lclInfo.lclInfo.Contact.F_Telephone || '--' }}</p>
        <p>电子邮件：{{ lclInfo.lclInfo.Contact.F_Email || '--' }}</p>
      </div>

      <div class="lcltext-item">
        <p>海运费及附加费</p>
        <p>合计：{{ lclInfo.freightTotal }}</p>
        <div v-for="(value, index) in lclInfo.freight" :key="index">
          <p>{{ value.F_ExpenseCode }}</p>
          <div v-if="value.F_QuotedPrice && value.F_QuotedPrice !== 'CASE BY CASE'">
            <p>{{ Number(value.F_QuotedPrice) < 0 ? '(' + Number(value.F_QuotedPrice) * -1 + ')' :
              value.F_QuotedPrice}}{{ value.F_Currency }}*{{ Number(value.F_Quantity) }}{{ value.F_Unit }}={{ Number(value.F_QuotedAmount) < 0 ? '('
                  + Number(value.F_QuotedAmount) * -1 + ')' : Number(value.F_QuotedAmount)}}{{ value.F_Currency }}</p>
          </div>
          <p v-else-if="value.F_QuotedPrice === 0">0</p>
          <p v-else>CASE BY CASE</p>
        </div>
        <p>{{ lclInfo.lclInfo.F_BookingRemarks }}</p>
      </div>

      <!-- 起运港费用 -->

      <div class="lcltext-item">
        <p>起运港费用</p>
        <p>合计：{{ lclInfo.polTotal }}</p>
        <p>折算美金：{{ lclInfo.convertTotal }}USD</p>
        <div v-for="(value, index) in lclInfo.polFee" :key="index">
          <p>{{ value.F_ExpenseCode }}</p>
          <div v-if="value.F_QuotedPrice && value.F_QuotedPrice !== 'CASE BY CASE'">
            <p>{{ Number(value.F_QuotedPrice) < 0 ? '(' + Number(value.F_QuotedPrice) * -1 + ')' :
              value.F_QuotedPrice}}{{ value.F_Currency }}*{{ Number(value.F_Quantity) }}{{ value.F_Unit }}={{ Number(value.F_QuotedAmount) < 0 ? '('
                  + Number(value.F_QuotedAmount) * -1 + ')' : Number(value.F_QuotedAmount)}}{{ value.F_Currency }}</p>
          </div>
          <p v-else-if="value.F_QuotedPrice === 0">0</p>
          <p v-else>CASE BY CASE</p>
          <p v-if="value.F_Remark">备注：{{ value.F_Remark || '--' }}</p>
        </div>
        <p v-if="lclInfo.textareaPol">{{ lclInfo.textareaPol }}</p>
      </div>

      <div class="lcltext-item">
        <p>目的港费用</p>
        <p>合计：{{ lclInfo.podTotal }}</p>
        <p>类型合计：{{ lclInfo.typeTotal }}</p>
        <div v-for="(value, index) in lclInfo.podFee" :key="index">
          <p>{{ value.F_ExpenseCode }}</p>
          <div v-if="value.F_QuotedPrice && value.F_QuotedPrice !== 'CASE BY CASE'">
            <p>{{ Number(value.F_QuotedPrice) < 0 ? '(' + Number(value.F_QuotedPrice) * -1 + ')' :
              value.F_QuotedPrice}}{{ value.F_Currency }}*{{ Number(value.F_Quantity) }}{{ value.F_Unit }}={{ Number(value.F_QuotedAmount) < 0 ? '('
                  + Number(value.F_QuotedAmount) * -1 + ')' : Number(value.F_QuotedAmount)}}{{ value.F_Currency }}</p>
          </div>
          <p v-else-if="value.F_QuotedPrice === 0">0</p>
          <p v-else>CASE BY CASE</p>
          <p v-if="value.F_Remark">备注：{{ value.F_Remark || '--' }}</p>
        </div>
        <p v-if="lclInfo.textareaPod">{{ lclInfo.textareaPod }}</p>
      </div>

      <div class="lcltext-item">
        <p>陆运费用</p>
        <p>合计：{{ lclInfo.landTotal }}</p>
        <div v-for="(value, index) in lclInfo.landFee" :key="index">
          <p>{{ value.F_ExpenseCode }}</p>
          <div v-if="value.F_QuotedPrice && value.F_QuotedPrice !== 'CASE BY CASE'">
            <p>{{ Number(value.F_QuotedPrice) < 0 ? '(' + Number(value.F_QuotedPrice) * -1 + ')' :
              value.F_QuotedPrice}}{{ value.F_Currency }}*{{ Number(value.F_Quantity) }}{{ value.F_Unit }}={{ Number(value.F_QuotedAmount) < 0 ? '('
                  + Number(value.F_QuotedAmount) * -1 + ')' : Number(value.F_QuotedAmount)}}{{ value.F_Currency }}</p>
          </div>
          <p v-else-if="value.F_QuotedPrice === 0">0</p>
          <p v-else>CASE BY CASE</p>
          <p v-if="value.F_Remark">备注：{{ value.F_Remark || '--' }}</p>
        </div>
        <p v-if="lclInfo.textareaPod">{{ lclInfo.textareaPod }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LclIText',
  data() {
    return {
      lclInfo: {
        lclInfo: {
          Contact: {},
          Efw_WarehouseArr: []
        }
      },
      copyText: ''
    }
  },

  mounted() {
    setTimeout(() => {
      this.lclInfo = window.sessionStorage.getItem("pdfData") ? JSON.parse(window.sessionStorage.getItem("pdfData")) : ""
      console.log(this.lclInfo)
    }, 1000)
  },

  methods: {
    copyTextEvent() {
      // 获取所有的 lcltext-item 元素
      const items = document.querySelectorAll('.lcltext-item')
      if (!items || items.length === 0) {
        this.$message.error('复制失败：未找到内容')
        return
      }

      // 处理每个 item 的文本内容
      const textArray = []
      items.forEach(item => {
        // 获取当前 item 的所有 p 标签和 div 内容
        const paragraphs = item.querySelectorAll('p')
        const itemText = []
        
        paragraphs.forEach(p => {
          const text = p.innerText.trim()
          if (text) {
            itemText.push(text)
          }
        })
        
        if (itemText.length > 0) {
          textArray.push(itemText.join('\n'))
        }
      })

      // 用空行分隔每个 item
      const textToCopy = textArray.join('\n\n')

      // 使用 Clipboard API 复制
      if (navigator.clipboard && window.isSecureContext) {
        // 现代浏览器
        navigator.clipboard.writeText(textToCopy).then(() => {
          this.$message.success('复制成功')
        }).catch(err => {
          console.error('复制失败:', err)
          this.$message.error('复制失败')
        })
      } else {
        // 兼容旧版浏览器
        const textarea = document.createElement('textarea')
        textarea.value = textToCopy
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        
        try {
          document.execCommand('copy')
          this.$message.success('复制成功')
        } catch (err) {
          console.error('复制失败:', err)
          this.$message.error('复制失败')
        }
        
        document.body.removeChild(textarea)
      }
    }
  }

}
</script>
<style scoped>
.lcltext {
  position: relative;
  width: 750px;
  background: #fff;
  margin: 0 auto;
  padding: 24px;

  .copy-text-btn {
    position: absolute;
    right: 12px;
    top: 12px;
  }

  .lcltext-item {
    margin-bottom: 30px;

    p {
      font-size: 14px;
      color: #555;
      margin-bottom: 5px;
    }
  }
}
</style>